import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
    { path: '', redirectTo: '/app/home', pathMatch: 'full' },
    {
        path: 'account',
        loadChildren: () => import('account/account.module').then(m => m.AccountModule), // Lazy load account module
        data: { preload: true }
    },
    {
        path: 'prontuario',
        loadChildren: () => import('prontuario-medico-token/prontuario-medico-token.module').then(m => m.ProntuarioMedicoTokenModule), // Lazy load account module
        data: { preload: true }
    },
    {
        path: 'app',
        loadChildren: () => import('app/app.module').then(m => m.AppModule), // Lazy load account module
        data: { preload: true }
    },
    {
        path: ':tenancyName',
        loadChildren: () => import('account/custom-account.module').then(m => m.CustomAccountModule), // Lazy load account module
        data: { preload: true },
    },
    {
        path: 'assinatura',
        loadChildren: () => import('assinatura/assinatura.module').then(m => m.AssinaturaModule), // Lazy load account module
        data: { preload: true }
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    providers: []
})
export class RootRoutingModule { }
